<template>
    <div class="main__top">
        <slot name="header"/>
    </div>
</template>

<script>
export default {
    name: 'ProfileTitle',
}

</script>

<style scoped>

</style>
